import { event } from '@uhg-abyss/web/tools/event';
import { providerEvent } from './events';
import {
  getOrganizationsRequest,
  getTaxIdNumbersRequest,
  getProvidersRequest,
  getSavedProviderRequest,
  postSavedProviderRequest,
} from './requests';

export const getOrganizationsSaga = async ({ action }) => {
  const data = await getOrganizationsRequest(action.payload);
  return data;
};

export const getTaxIdNumbersSaga = async ({ action }) => {
  const data = await getTaxIdNumbersRequest(action.payload);
  return data;
};

export const getProvidersSaga = async ({ action }) => {
  const data = await getProvidersRequest(action.payload);
  return data;
};

export const getSavedProviderSaga = async ({ action }) => {
  event.setData(providerEvent());
  const [provider, organizations] = await Promise.all([
    await getSavedProviderRequest(action.payload),
    await getOrganizationsRequest(action.payload),
  ]);

  let permissions = [];

  if (organizations) {
    const foundOrg = organizations.find((org) => {
      return org.id === provider.organizationId;
    });
    const providerOrg = foundOrg || organizations[0];

    if (providerOrg) {
      permissions = providerOrg.permissions || [];
    }
  }
  event.setData(providerEvent(provider));

  return { provider, permissions, organizations };
};

export const postSavedProviderSaga = async ({ action }) => {
  event.setData(providerEvent());
  const data = await postSavedProviderRequest(action.payload);
  event.setData(providerEvent(action.payload));
  return data;
};
